import * as THREE from 'three';
import { makeBifoldDoor } from '../scene/bifold';
import { makeSwingDoor } from '../scene/swing';
import { makePivotDoor } from '../scene/pivot';
import { runMeasurements } from './runMeasurements';
import { applyMetricUVs } from '../scene/materialGeometry';

export const makeSwingReplacement = (design, product, materials, frame) => makeBifoldReplacement(design, product, materials, frame, makeSwingDoor);
export const makePivotReplacement = (design, product, materials, frame) => makeBifoldReplacement(design, product, materials, frame, makePivotDoor);
export function makeBifoldReplacement(design, product, materials, frame, build = makeBifoldDoor) {
  const width = design.run_a.width_in * .0254, height = design.height_in * .0254;
  const model = build(product, materials, { width, height, layout: design.bifold_layout, leaves: design.swing_leaves, direction: design.pivot_direction || design.swing_direction, pivotPercent: design.pivot_offset_pct, hand: design.swing_hand, threshold: design.swing_threshold, top: design.swing_top, frame, dividers: design.dividers, fraction: design.openings.a / 100 });
  const measures = runMeasurements(width, height, design.run_a.width_in, false, 'a');
  model.group.add(measures);
  model.group.userData.dividers = design.dividers;
  const run = { group: model.group, measures, animate: model.animate, screen: null, width, height, panelWidth: model.panelWidth, count: model.count, tracks: 0, depth: model.depth ?? .086, side: 'a' };
  const group = new THREE.Group(); group.add(model.group); group.userData.bifold = true;
  applyMetricUVs(group);
  return { group, runs: [run] };
}
